<template>
	<div class="d-flex align-items-center justify-content-center not-found">
		<div class="text-center text-secondary px-3">
			<h1 class="text-nowrap" style="font-size: 128px">404</h1>
			<h1 style="font-size: 24px">Halaman tidak ditemukan</h1>
		</div>
	</div>
</template>

<script>
export default {
	name: "NotFound",
	mounted() {
		this.$emit("layout-updated");
	},
};
</script>

<style scoped>
.not-found {
	position: fixed;
	top: 60px;
	height: calc(100vh - 60px);
	filter: drop-shadow(0 0 2px #eeefff) drop-shadow(0 0 4px #eeefff) drop-shadow(0 0 4px #eeefff) drop-shadow(0 0 8px #173a65) drop-shadow(0 0 16px #eeefff);
}
</style>
